 /*
  Bedz King main.v2.02.js
  Purpose: clean replacement for main.patch.js
  Milestone: v2.02 foundation + collection mobile refine/sort module
*/

(function ($) {
  'use strict';

  function afterResize(callback, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(callback, delay || 250);
    };
  }

  function equalHeights($items) {
    var maxHeight = 0;
    if (!$items.length) return;

    $items.css('height', 'auto');

    $items.each(function () {
      var itemHeight = $(this).innerHeight();
      if (itemHeight > maxHeight) maxHeight = itemHeight;
    });

    if (maxHeight > 0) $items.css('height', maxHeight);
  }

  
   function initSearchAndMenu() {
  $(document)
    .off('click.mainV2Search', '.search-btn')
    .on('click.mainV2Search', '.search-btn', function (event) {
      event.preventDefault();

      var $search = $('#search-container');
      $search.toggleClass('hide');
      $(event.currentTarget).toggleClass('_open');
      $search.find('input[type="search"]').focus();
    });

  $(document)
    .off('click.mainV2Menu', '.menu-btn')
    .on('click.mainV2Menu', '.menu-btn', function (event) {
      event.preventDefault();

      $('#menu-container').toggleClass('hide');
      $(event.currentTarget).toggleClass('_open');
    });

  $(document)
    .off('click.mainV2MenuSection', '#menu-container .section-header')
    .on('click.mainV2MenuSection', '#menu-container .section-header', function (event) {
      $(event.currentTarget).next('.sidebar-module__list').toggleClass('hide');
      $(event.currentTarget).toggleClass('_open');
    });

  $(document)
    .off('click.mainV2TabletSection', '#menu-container-tablet .section-header')
    .on('click.mainV2TabletSection', '#menu-container-tablet .section-header', function (event) {
      $('#menu-container-tablet .section-header._open')
        .not(event.currentTarget)
        .each(function () {
          $(this).removeClass('_open');
          $(this).next('.sidebar-module__list').addClass('hide');
        });

      $(event.currentTarget).next('.sidebar-module__list').toggleClass('hide');
      $(event.currentTarget).toggleClass('_open');
    });
}

function initMobileNav() {
  $(document)
    .off('click.mainV2MobileNav', '#MobileNavTrigger')
    .on('click.mainV2MobileNav', '#MobileNavTrigger', function (event) {
      event.preventDefault();
      $('#MobileNav').slideToggle(220);
    });

  $(document)
    .off('click.mainV2MobileSublist', '.mobile-nav__sublist-trigger')
    .on('click.mainV2MobileSublist', '.mobile-nav__sublist-trigger', function (event) {
      event.preventDefault();
      $(this).toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    });
}
  function initHomepagePromoProducts() {
    var $hiddenSaleItems = $('#_sale-items ul.products > li.hide');
    if (!$hiddenSaleItems.length) return;

    var indexes = [];

    for (var i = 0; i < $hiddenSaleItems.length; i++) indexes.push(i);

    indexes = indexes.sort(function () {
      return 0.5 - Math.random();
    }).slice(0, 6);

    for (var j = 0; j < $hiddenSaleItems.length; j++) {
      if (indexes.indexOf(j) !== -1) $($hiddenSaleItems[j]).removeClass('hide');
    }
  }

  function initEqualHeights() {
    function run() {
      equalHeights($('.grid-link__image--product'));
      equalHeights($('.grid-link__image--collection'));
    }

    run();
    $(window).on('load.mainV2', run);
    $(window).on('resize.mainV2', afterResize(run, 250));
  }

  function initSidebarDropdowns() {
    $('.sidebar-module__viewmore').on('click.mainV2', function () {
      $(this).prev('.sidebar-module__list').toggleClass('sidebar-module__list--expand');
    });

    $('.sidebar-sublist__expand').on('click.mainV2', function () {
      $(this).closest('.sidebar-sublist').addClass('is-open');
    });

    $('.sidebar-sublist__contract').on('click.mainV2', function () {
      $(this).closest('.sidebar-sublist').removeClass('is-open');
    });

    $('.sidebar-sublist__content').each(function () {
      var $sublist = $(this);
      if ($sublist.find('.is-active').length) {
        $sublist.parent('.sidebar-sublist').addClass('is-open');
      }
    });
  }

  function initTabSwitcher() {
    var $triggers = $('.tab-switch__trigger');
    var $contents = $('.tab-switch__content');

    if (!$triggers.length) return;

    $contents.filter(':gt(0)').addClass('is-hidden');
    $triggers.first().addClass('is-active');

    $triggers.on('click.mainV2', function (event) {
      event.preventDefault();

      var $trigger = $(this);
      var link = $trigger.data('link');

      $triggers.removeClass('is-active');
      $trigger.addClass('is-active');

      $contents.addClass('is-hidden');
      $contents.filter('[data-content="' + link + '"]').removeClass('is-hidden');
    });
  } 
  
  function initFooterNavCollapse() {
    var links = document.querySelectorAll('footer a[data-toggle="collapse"], .footer a[data-toggle="collapse"]');

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();

        var targetSelector = link.getAttribute('href');
        if (!targetSelector || targetSelector.charAt(0) !== '#') return;

        var target = document.querySelector(targetSelector);
        if (!target) return;

        var isOpen = target.classList.contains('in');

        if (isOpen) {
          target.classList.remove('in');
          target.style.display = 'none';
          link.classList.add('collapsed');
          link.setAttribute('aria-expanded', 'false');
        } else {
          target.classList.add('in');
          target.style.display = 'block';
          link.classList.remove('collapsed');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initCollectionRefineSort() {
    $('#mobile-refine-sort-btns > div').on('click.mainV2', function (event) {
      var button = event.currentTarget;
      var buttonId = button.id;
      var $button = $(button);
      var $matchingList = $('#isp_container ul[data-btn-id="' + buttonId + '"]');

      if ($button.hasClass('_open')) {
        $button.removeClass('_open');
        $matchingList.removeClass('_open');
        return;
      }

      $('#mobile-refine-sort-btns > div').not(button).removeClass('_open');
      $('#isp_container ul[data-btn-id!="' + buttonId + '"]').removeClass('_open');

      $button.addClass('_open');
      $matchingList.addClass('_open');
    });
  }
   
function initBedzHeaderButtons() {
  $(document)
    .off('click.bedzHeaderSearch')
    .on('click.bedzHeaderSearch', 'a.search-btn', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      $('#search-container').toggleClass('hide');
      $(this).toggleClass('_open');
      $('#search-container').find('input[type="search"]').first().focus();
    });

  $(document)
    .off('click.bedzHeaderMenu')
    .on('click.bedzHeaderMenu', 'a.menu-btn', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      $('#menu-container').toggleClass('hide');
      $(this).toggleClass('_open');
    });
}

  $(function () {
    initSearchAndMenu();
    initBedzHeaderButtons();
    initMobileNav();
    initHomepagePromoProducts();
    initEqualHeights();
    initSidebarDropdowns();
    initTabSwitcher();
    initFooterNavCollapse();
    initCollectionRefineSort();

    console.log('main.v2.02.js loaded');
  });

})(jQuery);